<div class="sidebar-outer">
    <a class="logo d-flex align-items-center" routerLink="/" (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
        <!-- <span class="start">start</span><span class="ng">NG</span> -->
        <img src="./assets/icons/logo.png" class="logo"> 
    </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>